import store from '@/store/opentowork'

export default {
	name: 'opentoworkApp',
	store
}
